import { FC, ReactNode, useEffect } from 'react';
import { Spin, Tag } from 'antd';
import { CheckCircleOutlined, CloseCircleOutlined, SyncOutlined } from '@ant-design/icons';

import { usePmpFetch } from '@pmp/hooks';

type ProductBoSyncStatusProps = {
  productCode: string;
};

const TAGS: Record<string, { color: string; icon: ReactNode }> = {
  OK: { color: 'success', icon: <CheckCircleOutlined /> },
  PENDING: { color: 'processing', icon: <SyncOutlined /> },
  FAILED: { color: 'error', icon: <CloseCircleOutlined /> },
};

export const ProductBoSyncStatus: FC<ProductBoSyncStatusProps> = ({ productCode }) => {
  const [, error, data, , fetchStatus] = usePmpFetch('productsGetBoSyncStatus', { notifyOnError: false });

  useEffect(() => {
    fetchStatus({ path: { productCode } });
  }, [fetchStatus, productCode]);

  if (error) return '-';
  if (!data) return <Spin size="small" />;

  const tag = TAGS[data.status.key];

  return (
    <Tag color={tag?.color} icon={tag?.icon}>
      {data.status.value}
    </Tag>
  );
};
